import { wrapCall, callGet } from './helpers'

// Gets timezone list
export const getTimezones = async () => {
  return await wrapCall({ method: callGet, uri: '/timezones' })
}
